<ng-select class="select-bassa select-auto-grow"
           [items]="items"
           [disabled]="disabled"
           [clearable]="false"
           [(ngModel)]="value"
           (ngModelChange)="onChanged($event)">
  <ng-template ng-label-tmp let-item="item">
    <span class="fw-bold">{{ item.name }}</span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <div class="custom-option">
      <span class="fw-bold">{{ item.name }} - {{ item.percentage }}</span>
      <div>
        <small class="text-muted">{{ item.description }}</small>
      </div>
    </div>
  </ng-template>
</ng-select>